import LogTable from './log_table.vue';

export default LogTable;
